import Nexo from "../../static/nexo.png";

export const getPng = async (name?: string): Promise<string> => {
  let image = "";
  try {
    image = (await import(`../../src/content/png/${name || "cover"}.png`))
      .default;
  } catch {
    image = Nexo;
  } finally {
    return image;
  }
};

export default getPng;
